import { createTermsQuery, emptyDataObject, SourceInfo } from "../info";
import { uppercaseFirstLetterOnly } from "../../util/strings";
import { dateFormat } from "../../util/date";
import { SelectedMetadataInterface } from "../../interfaces/ElasticSearchInterface";

import {AGGREGATION_SIZE} from "@me8eon/config";

const index = "jira-prod";

export const jiraInfo: SourceInfo = {
    match: "jira",
    dropDown: {
        label: "JIRA",
        value: index,
        icon: "jira",
    },
    dateFilter: (index: string, { start, now }) => ({
        bool: {
            must: [
                { term: { _index: index } },
                {
                    range: {
                        last_updated: {
                            gte: start,
                            lte: now,
                            format: "yyyy-MM-dd",
                        },
                    },
                },
            ],
        },
    }),
    titleAndTarget: (result) => ({
        title: `${result?.issue}:${result?.summary}`,
        target: result?.url,
        source: "JIRA",
    }),
    makeDataObject: (result) => ({
        ...emptyDataObject,
        id: result.id,
        index: result.index,
        icon: "jira",
        link: result.url || result.self,
        name: `${result.issue}: ${result.summary}`,
        source: "JIRA",
        status: uppercaseFirstLetterOnly(result.status),
        desc: result.description || result.body || result.comments,
        createdBy: result.created_by,
        lastUpdate: dateFormat(result.last_updated),
        render: "markdown",
    }),
    dateFilterKey: "last_updated",
    refineFiltersAggregationQuery: {
        [index]: {
            filter: {
                term: {
                    _index: index,
                },
            },
            aggs: {
                status: {
                    terms: {
                        field: "status.keyword",
                        size: AGGREGATION_SIZE
                    },
                },
                priority: {
                    terms: {
                        field: "priority.keyword",
                        size: AGGREGATION_SIZE
                    },
                },
            },
        }
    },
    createMetadataFilters: (selectedMetadata: SelectedMetadataInterface): any => {
        const searchQuery = [];
        for (const key in selectedMetadata) {
            if (!selectedMetadata[key].length) continue;
            switch (key) {
                case "status":
                case "priority": {
                    const termsQuery = createTermsQuery(selectedMetadata, key);
                    termsQuery && searchQuery.push(termsQuery);
                    break;
                }
                default:
                    return [];
            }
        }
        return searchQuery;
    },
};
